import ShiftManagementApp from './../Functionality/ShiftManagementApp';
import CustomAddRemoveItemsModal from './../../../../../components/AddRemoveItemsModal/CustomAddRemoveItemsModal';
import {TABLES} from "../../../../../Apis/Tables";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ShiftManagementModal = ({show, onHide, selectedId, setModified, modified }) => {

    const { handleDelete, handleAdd, selectedEmployee } = ShiftManagementApp({
        onHide,
        selectedId,
        setModified,
        modified
    });

    return (
        <CustomAddRemoveItemsModal
            show={show}
            onHide={onHide}
            selected={selectedEmployee}
            handleDelete={handleDelete}
            handleAdd={handleAdd}
            option={TABLES.USER_NOT_ASSIGNED_TO_WORK_SCHEDULE}
            modelId={selectedId}
            listTransform={userListToLabelEmailPhoneValue}
        />
    );
};

export default ShiftManagementModal;
